import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class MyModulesStateModel extends PaginatedSubentityStateModel {
    static identifier = 'MyModulesStateModel';

    constructor() {
        super(MyModulesStateModel.identifier);
    }
}
